import { render, staticRenderFns } from "./myexam.vue?vue&type=template&id=43485c53&"
import script from "./myexam.vue?vue&type=script&lang=js&"
export * from "./myexam.vue?vue&type=script&lang=js&"
import style0 from "./myexam.vue?vue&type=style&index=0&id=43485c53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports